import React from 'react';
import styled from 'styled-components';
import { Level } from 'rbx';
import { Link, withRouter } from 'react-router-dom';

const Wrapper = styled.div`
  padding: 0rem 1rem;
  padding-bottom: 1rem;
`;

const Footer = ({ isSubmitting, handleSubmit }) => (
  <Wrapper>
    <Level>
      <Level.Item align="left">
        <Level.Item>
          <Link to="/block-users" className="button is-light">
            <span>Cancel</span>
          </Link>
        </Level.Item>
      </Level.Item>
      <Level.Item align="right">
        <Level.Item>
          <button
            type="submit"
            className={`button is-primary ${isSubmitting && 'is-loading'}`}
            onClick={handleSubmit}
          >
            <span>Submit</span>
          </button>
        </Level.Item>
      </Level.Item>
    </Level>
  </Wrapper>
);

export default withRouter(Footer);
